import { useNavigate } from 'react-router-dom'
import { CategoryForm } from "@univdiam/ui/customComponents/CategoryList/CategoryForm"
import api from '@/http/api'

export default function CategoryAdd() {

    const navigate = useNavigate()

    const handleAddCategory = async (data: any) => {
        try {
            const response = await api.post("/api/category/add", data)

            if (response.status === 201 || response.status === 200) {
              alert("Category created successfully!")
              navigate("/category")
            }
        } catch (error) {
            console.error("Error creating category:", error)
            alert("Failed to create category.")
        }
    }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Category</h1>
      <CategoryForm onSubmit={handleAddCategory} />
    </div>
  )
}
